<template>
<v-container>
  <v-layout row v-show="errorMessage">
    <v-flex xs12>
      <app-alert @dismissed="onDismissed" :msg="errorMessage" type="error"/>
    </v-flex>
  </v-layout>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elevation-11">
        <v-card-text>
          <v-container>
            <h2 class="mb-4">Add New Student</h2>
            <form @submit.prevent="onSignUp">
              <v-text-field
                name="fname"
                label="First name"
                id="fname"
                type="text"
                autofocus
                v-model.trim="fname"
                required>
              </v-text-field>

              <v-text-field
                name="lname"
                label="Last name"
                id="lname"
                type="text"
                v-model.trim="lname"
                required>
              </v-text-field>

              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model.trim="email"
                required>
              </v-text-field>

              <v-layout row class="mt-4">
                <v-flex xs12>
                  <v-btn small type="submit" class="secondary">Submit</v-btn>
                  <v-btn small class="ml-2" @click="$router.replace('/admin')">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      fname: "",
      lname: "",
      email: ""
    };
  },
  computed: {
    errorMessage() {
      return this.$store.getters.getError;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.replace("/");
      }
    }
  },
  methods: {
    onSignUp() {
      let fullName = this.fname.trim() + " " + this.lname.trim();
      let pwd = this.fname.toLowerCase() + "123";
      const newUser = {
        email: this.email,
        password: pwd,
        fname: this.fname,
        lname: this.lname
      };

      if (
        confirm(
          "You added " +
            fullName +
            ", email: " +
            this.email +
            " password: " +
            pwd
        )
      ) {
        this.$store.dispatch("setType", "students");
        this.$store.dispatch("signUp", newUser);
      }
    },
    onDismissed() {
      this.$store.commit("clearError");
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      setTimeout(() => {
        this.passwordFieldType = "password";
      }, 2000);
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0px;
}
h2{
  font-size: 1.4rem;
}

.show {
  font-size: 11px;
  text-decoration: underline;
  margin-bottom: 20px;
  margin-top: 10px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>